<template>
  <component
    :is="iconComponentName"
    :class="{
      'platform-icon': true,
      'platform-icon--small': small,
    }"
  />
</template>

<script>
  import DealabsIcon from '../assets/img/platforms/Dealabs'
  import MydealzIcon from '../assets/img/platforms/MyDealz'
  import PepperIcon from '../assets/img/platforms/Pepper'
  export default {
    props: {
      country: {
        type: String,
        default: ''
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      DealabsIcon,
      MydealzIcon,
      PepperIcon,
    },
    computed: {
      iconComponentName() {
        switch (this.country) {
          case 'DE':
            return 'MydealzIcon';
          case 'FR':
            return 'DealabsIcon';
          default:
            return 'PepperIcon';
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .platform-icon {
    &--small {
      width: 20px;
      height: 20px;
    }
  }
</style>
